import * as Yup from 'yup'

const NewVisitReasonSchema = Yup.object().shape({
  reasonForVisit: Yup.string().max(350, 'Reason for visit must not exceed 350 characters.').required(),
})

export default NewVisitReasonSchema
